export default "__VITE_ASSET__BXbH_XmI__"